// extracted by extract-css-chunks-webpack-plugin
module.exports = {"left_box":"left_box-1abxweM6","dbox":"dbox-15ucCTla"};